import axios from "axios";
import { toNormalForm } from "./DataManager";

export async function getVideosFromPlaylists(categories, url) {

  var video = {};
  return axios.get(url, {
    headers: {
      accept: 'application/json'
    }
  }).then((response) => {

    var video = {};
    var videos = [];
    if((response.data.playlist).length > 0) {
      
      response.data.playlist.map(media => {
        video = { id: media.mediaid, title: media.title, flatTitle: toNormalForm(media.title), description: media.description, duration: media.duration, creationDate: media.pubdate, url: media.sources[0].file, thumbnail: media.image};
          videos.push(video);
      });

      categories.forEach((cat) => {
        if(cat.name === response.data.title) {
          cat.id = response.data.feedid;
          cat.description = response.data.description;
          cat.videos = videos;
        }
      });
    }
  });
}